// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AgreementItem_wrapper___kILt","container":"AgreementItem_container__3ZRuo"};